import React from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';
import './toast.css';

export type ToasterProps = React.ComponentProps<typeof SonnerToaster>;

// The × stamped on the dog-ear: two square-cut strokes, printed rather than drawn.
const FoldCross = (
  <svg viewBox="0 0 10 10" aria-hidden="true" focusable="false">
    <path d="M2 2l6 6M8 2L2 8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square" />
  </svg>
);

/**
 * A toast is a slip taped to the corner of the desk (desk.css .br-note), not a
 * floating SaaS card. The list carries `br-desk` so the note's tokens reach it
 * outside the workspace tree; an error is the amber slip, never a bear. Its
 * top-right corner is dog-eared, and the dog-ear dismisses it (toast.css).
 */
const Toaster: React.FC<ToasterProps> = (props) => (
  <SonnerToaster
    position="bottom-right"
    className="br-desk br-toaster"
    closeButton
    icons={{ close: FoldCross }}
    toastOptions={{
      unstyled: true,
      closeButtonAriaLabel: 'Dismiss notification',
      classNames: {
        toast: 'br-note br-note--straight br-toast',
        title: 'font-display font-bold',
        description: 'br-small',
        error: 'br-note--amber',
        closeButton: 'br-toast__fold',
        actionButton: 'br-slab br-slab--cream br-slab--sm mt-1',
        cancelButton: 'br-inkline mt-1',
      },
    }}
    {...props}
  />
);

export { Toaster, toast };
